import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, NgModule, Injectable } from '@angular/core';
import * as i3 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i1 from '@angular/router';
import { RouterModule } from '@angular/router';
import { HttpErrorResponse, HTTP_INTERCEPTORS } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

const xpoErrorPageStatusCodeMap = new Map([
    [
        403,
        {
            status: 403,
            summary: 'Forbidden',
            detail: 'You do not have permission to access this application',
        },
    ],
    [
        404,
        {
            status: 404,
            summary: 'Page Not Found',
            detail: 'We\'re sorry, but we could not find the page you are looking for.',
            link: { route: '/', label: 'Go To Homepage' },
        },
    ],
]);

function XpoErrorPage_p_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 4);
    i0.ɵɵelementStart(1, "a", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("routerLink", ctx_r0.errorPageData.link.route);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.errorPageData.link.label);
} }
class XpoErrorPage {
    constructor(route) {
        this.route = route;
        this.errorPageData = xpoErrorPageStatusCodeMap.get(404);
        const statusCode = this.route.snapshot.data['statusCode'];
        if (statusCode) {
            this.errorPageData = xpoErrorPageStatusCodeMap.get(statusCode) || { status: statusCode, summary: '', detail: '' };
        }
    }
}
XpoErrorPage.ɵfac = function XpoErrorPage_Factory(t) { return new (t || XpoErrorPage)(i0.ɵɵdirectiveInject(i1.ActivatedRoute)); };
XpoErrorPage.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoErrorPage, selectors: [["xpo-error-page"]], hostAttrs: [1, "xpo-ErrorPage"], decls: 7, vars: 4, consts: [[1, "xpo-ErrorPage-statusCode"], [1, "xpo-ErrorPage-summary"], [1, "xpo-ErrorPage-detail"], ["class", "xpo-ErrorPage-link", 4, "ngIf"], [1, "xpo-ErrorPage-link"], ["mat-button", "", "color", "primary", 3, "routerLink"]], template: function XpoErrorPage_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "h1", 0);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "p", 1);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "p", 2);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, XpoErrorPage_p_6_Template, 3, 2, "p", 3);
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.errorPageData.status);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.errorPageData.summary);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.errorPageData.detail);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errorPageData.link);
    } }, directives: [i2.NgIf, i3.MatAnchor, i1.RouterLinkWithHref], styles: [".flex--stretch{flex:1}.xpo-ErrorPage{align-items:center;display:flex;flex-direction:column;height:100%;justify-content:center}.xpo-ErrorPage-statusCode,.xpo-ErrorPage-summary,.xpo-ErrorPage-link{margin:0}.xpo-ErrorPage-statusCode{color:#f22;font-size:7rem;line-height:1}.xpo-ErrorPage-summary{font-size:1.143rem;font-weight:500;text-transform:uppercase}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoErrorPage, [{
        type: Component,
        args: [{
                selector: 'xpo-error-page',
                templateUrl: './error-page.html',
                styleUrls: ['./error-page.scss'],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: { class: 'xpo-ErrorPage' },
            }]
    }], function () { return [{ type: i1.ActivatedRoute }]; }, null); })();

class XpoErrorPageModule {
}
XpoErrorPageModule.ɵfac = function XpoErrorPageModule_Factory(t) { return new (t || XpoErrorPageModule)(); };
XpoErrorPageModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoErrorPageModule });
XpoErrorPageModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, RouterModule, MatButtonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoErrorPageModule, [{
        type: NgModule,
        args: [{
                declarations: [XpoErrorPage],
                imports: [CommonModule, RouterModule, MatButtonModule],
                exports: [XpoErrorPage],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoErrorPageModule, { declarations: [XpoErrorPage], imports: [CommonModule, RouterModule, MatButtonModule], exports: [XpoErrorPage] }); })();

const routes$1 = [{ path: '**', component: XpoErrorPage }];
class XpoPageNotFoundRoutingModule {
}
XpoPageNotFoundRoutingModule.ɵfac = function XpoPageNotFoundRoutingModule_Factory(t) { return new (t || XpoPageNotFoundRoutingModule)(); };
XpoPageNotFoundRoutingModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoPageNotFoundRoutingModule });
XpoPageNotFoundRoutingModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, XpoErrorPageModule, RouterModule.forChild(routes$1)], RouterModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoPageNotFoundRoutingModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, XpoErrorPageModule, RouterModule.forChild(routes$1)],
                exports: [RouterModule],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoPageNotFoundRoutingModule, { imports: [CommonModule, XpoErrorPageModule, i1.RouterModule], exports: [RouterModule] }); })();

class XpoForbiddenInterceptor {
    constructor(router) {
        this.router = router;
    }
    intercept(req, next) {
        return next.handle(req).pipe(catchError((errEvent) => {
            if (errEvent instanceof HttpErrorResponse && errEvent.status === 403) {
                this.router.navigate(['/403']);
            }
            return throwError(errEvent);
        }));
    }
}
XpoForbiddenInterceptor.ɵfac = function XpoForbiddenInterceptor_Factory(t) { return new (t || XpoForbiddenInterceptor)(i0.ɵɵinject(i1.Router)); };
XpoForbiddenInterceptor.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: XpoForbiddenInterceptor, factory: XpoForbiddenInterceptor.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoForbiddenInterceptor, [{
        type: Injectable
    }], function () { return [{ type: i1.Router }]; }, null); })();

const routes = [{ path: '403', component: XpoErrorPage, data: { statusCode: 403 } }];
class XpoForbiddenRoutingModule {
}
XpoForbiddenRoutingModule.ɵfac = function XpoForbiddenRoutingModule_Factory(t) { return new (t || XpoForbiddenRoutingModule)(); };
XpoForbiddenRoutingModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoForbiddenRoutingModule });
XpoForbiddenRoutingModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [{ provide: HTTP_INTERCEPTORS, useClass: XpoForbiddenInterceptor, multi: true }], imports: [[CommonModule, XpoErrorPageModule, RouterModule.forChild(routes)], RouterModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoForbiddenRoutingModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, XpoErrorPageModule, RouterModule.forChild(routes)],
                exports: [RouterModule],
                providers: [{ provide: HTTP_INTERCEPTORS, useClass: XpoForbiddenInterceptor, multi: true }],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoForbiddenRoutingModule, { imports: [CommonModule, XpoErrorPageModule, i1.RouterModule], exports: [RouterModule] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { XpoErrorPage, XpoErrorPageModule, XpoForbiddenInterceptor, XpoForbiddenRoutingModule, XpoPageNotFoundRoutingModule };
